function increaseQuantity(event, id) {
  event.preventDefault();
  document.querySelector(`quantity-input[id="Quantity-${id}"] .quantity__button[name="plus"]`).click();
}

function decreaseQuantity(event, id) {
  event.preventDefault();
  document.querySelector(`quantity-input[id="Quantity-${id}"] .quantity__button[name="minus"]`).click();
}

function formatEuroNlFromCents(cents) {
  return new Intl.NumberFormat('nl-NL', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  })
    .format((Number(cents) || 0) / 100)
    .replace(/\s+/g, '')
    .replace('€-', '-€');
}

function formatEuroNlFromAmount(amount) {
  return new Intl.NumberFormat('nl-NL', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  })
    .format(Number(amount) || 0)
    .replace(/\s+/g, '')
    .replace('€-', '-€');
}

function setTextForAll(selector, value) {
  document.querySelectorAll(selector).forEach((el) => {
    el.textContent = value;
  });
}


function findCartItemElement(item) {
  const itemKey = item?.key || item?.line_item_key || '';

  if (itemKey) {
    const keyMatch = Array.from(
      document.querySelectorAll('[data-cart-key]')
    ).find((element) => (
      element.getAttribute('data-cart-key') === String(itemKey)
    ));

    if (keyMatch) {
      return keyMatch;
    }
  }

  const variantId = String(item?.variant_id || '');
  const candidates = Array.from(
    document.querySelectorAll(`[data-cart-variant="${variantId}"]`)
  );

  if (candidates.length <= 1) {
    return candidates[0] || null;
  }

  const properties = item?.properties || {};
  const groupId = String(properties._bd_group_id || '');
  const itemType = String(properties._bd_item_type || '');

  return candidates.find((element) => (
    element.getAttribute('data-bd-group-id') === groupId &&
    element.getAttribute('data-bd-item-type') === itemType
  )) || candidates[0] || null;
}

document.addEventListener('bundler:loaded', function () {
  if (window.bndlr && typeof window.bndlr.updateCartDiscounts === 'function') {
    window.bndlr.updateCartDiscounts();
  }
});

document.addEventListener('bundler:total_cart_values', function (e) {
  const vatIncluded = sessionStorage.getItem('pricesIncludeVat');

  const {
    total_amount_original = 0,
    total_amount_discounted = 0,
    discount_amount = 0,
    discounted_cart_object = null,
  } = e.detail || {};

  // Overzicht rechts
  const originalSubtotal = Number(total_amount_original) || 0;
  const discountedSubtotal = Number(total_amount_discounted) || 0;
  const suppliedDiscount = Number(discount_amount) || 0;
  const calculatedDiscount = Math.max(
    0,
    originalSubtotal - discountedSubtotal
  );
  const effectiveDiscount = suppliedDiscount > 0
    ? suppliedDiscount
    : calculatedDiscount;
  const subtotalBeforeDiscount = originalSubtotal > 0
    ? originalSubtotal
    : discountedSubtotal + effectiveDiscount;
  const hasDiscount = effectiveDiscount > 0;

  setTextForAll(
    '#cart-price_original_subtotal',
    formatEuroNlFromCents(subtotalBeforeDiscount)
  );
  setTextForAll(
    '#cart-price_discount',
    `-${formatEuroNlFromCents(effectiveDiscount)}`
  );
  setTextForAll(
    '#cart-price_subtotal',
    formatEuroNlFromCents(discountedSubtotal)
  );

  document
    .querySelectorAll('[data-cart-discount-summary]')
    .forEach((el) => {
      if (hasDiscount) {
        el.classList.add('flex');
        el.classList.remove('hidden');
      } else {
        el.classList.remove('flex');
        el.classList.add('hidden');
      }
    });

  const totalTaxAmount = (discountedSubtotal * 0.21) / 100;
  setTextForAll('#cart-price_tax', formatEuroNlFromAmount(totalTaxAmount));

  const totalPriceAmount = (discountedSubtotal * 1.21) / 100;
  setTextForAll('#cart-price_total', formatEuroNlFromAmount(totalPriceAmount));

  // Productregels: totaalprijs van het gekozen aantal tonen
  if (discounted_cart_object && discounted_cart_object.items) {
    discounted_cart_object.items.forEach((item) => {
      const itemElement = findCartItemElement(item);

      if (!itemElement) {
        console.warn(
          `Cart item element not found for variant ID: ${item.variant_id}`
        );
        return;
      }

      const originalLinePrice =
        typeof item.original_line_price !== 'undefined'
          ? Number(item.original_line_price)
          : Number(item.line_price || 0);

      const discountedLinePrice =
        typeof item.line_price !== 'undefined'
          ? Number(item.line_price)
          : originalLinePrice;

      const hasDiscount =
        originalLinePrice > discountedLinePrice;

      const lineDiscountAmount = Math.max(
        0,
        originalLinePrice - discountedLinePrice
      );

      function formatDisplayPriceFromCents(cents) {
        if (vatIncluded == 'true') {
          return formatEuroNlFromAmount(
            ((Number(cents) || 0) * 1.21) / 100
          );
        }

        return formatEuroNlFromCents(cents);
      }

      const itemType = String(
        itemElement.getAttribute('data-bd-item-type') || ''
      );
      const isAccessory = itemType === 'accessory';
      const discountPercentage =
        originalLinePrice > 0
          ? Math.round((lineDiscountAmount / originalLinePrice) * 100)
          : 0;
      const showLineBenefit =
  hasDiscount && discountPercentage > 0;

      itemElement
        .querySelectorAll('[data-bd-line-benefit]')
        .forEach((element) => {
          const textElement = element.querySelector(
            '[data-bd-line-benefit-text]'
          );

          if (textElement) {
            textElement.textContent =
              `${discountPercentage}% korting · voordeel ${formatDisplayPriceFromCents(lineDiscountAmount)}`;
          }

          element.classList.toggle('hidden', !showLineBenefit);
          element.setAttribute(
            'aria-hidden',
            showLineBenefit ? 'false' : 'true'
          );
        });

      itemElement
        .querySelectorAll('[data-unit-price]')
        .forEach((el) => {
          el.textContent =
            formatDisplayPriceFromCents(
              discountedLinePrice
            );
        });

      itemElement
        .querySelectorAll('[data-old-unit-price]')
        .forEach((el) => {
          el.textContent =
            formatDisplayPriceFromCents(
              originalLinePrice
            );
        });

      itemElement
        .querySelectorAll(
          '[data-old-unit-price-wrapper]'
        )
        .forEach((el) => {
          if (hasDiscount) {
            el.classList.remove('hidden');
          } else {
            el.classList.add('hidden');
          }
        });
    });
  } else {
    console.warn('Discounted cart object is undefined or missing items.');
  }
});

var cartEvent = new CustomEvent('bundler:total_cart_values', {
  detail: {
    total_amount_original: 0,
  },
});

document.dispatchEvent(cartEvent);